export const renameFile = (file: File, name: string) => {
  const blob = file.slice(0, file.size, file.type);
  return new File([blob], `${name}.${file.type.split('/')[1]}`, { type: file.type });
};
